/* =============================================================================
   vp-menu-image.js — Menuebild fuer "Kollektionen"            (01.09.2026)

   Im aufklappbaren Menue tragen die Eintraege der zweiten Ebene unter SHOP
   ein kleines Vorschaubild. Das Theme nimmt dafuer das Bild der verlinkten
   Kollektion. "Kollektionen" zeigt auf die Uebersichtsseite /collections —
   dahinter steckt keine Kollektion, also gibt es auch kein Bild, und der
   Eintrag stand als einziger ohne.

   Warum hier und nicht im Theme-Editor: das Theme bietet fuer diesen
   Menuepunkt keine Bildeinstellung an; das Bild kommt allein aus dem
   verlinkten Objekt. Und warum kein Eingriff in sections/header.liquid: die
   Datei ist 134 KB gross und wird auch von anderer Seite bearbeitet.

   Vorgehen: das Markup wird nicht nachgebaut, sondern von einem
   Nachbareintrag derselben Liste geklont — damit ist es garantiert exakt
   dasselbe Format (Container, figure, lazy-image-Klassen). Getauscht werden
   nur Bildquelle und Alternativtext.

   Selbstabschaltend: sobald der Eintrag auf anderem Weg ein Bild bekommt
   (z. B. weil er auf eine echte Kollektion zeigt), findet das Skript bereits
   ein .menu__item-image vor und tut nichts.

   Ausfallweg ohne JavaScript: der Eintrag steht wie bisher ohne Bild.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__vpMenuImage) return;
  window.__vpMenuImage = true;

  var IMAGE = 'https://cdn.shopify.com/s/files/1/0947/4936/0514/files/TrueAlpine-Shampoo-Shower-Conditioner-500ml_2.jpg?v=1787673371';
  var HREF = '/collections';
  var ALT = 'Kollektionen';
  var WIDTHS = [80, 160, 240, 320];

  function sized(width) {
    return IMAGE + '&width=' + width;
  }

  /* Nachbarbild als Vorlage suchen: vom Eintrag aus nach oben, hoechstens
     fuenf Ebenen. Findet sich keines, ist das eine Liste ohne Bilder (etwa
     das Footer-Menue) — dann wird bewusst nichts eingesetzt. */
  function findTemplate(title) {
    var scope = title.parentElement;
    for (var i = 0; i < 5 && scope; i++) {
      var found = scope.querySelector('.menu__item-image');
      if (found) return found;
      scope = scope.parentElement;
    }
    return null;
  }

  function build() {
    var links = document.querySelectorAll('a.menu__item-link[href="' + HREF + '"]');

    Array.prototype.forEach.call(links, function (link) {
      var title = link.closest('.menu__item-title');
      if (!title) return;
      if (title.querySelector('.menu__item-image')) return;

      var template = findTemplate(title);
      if (!template) return;

      var clone = template.cloneNode(true);
      var img = clone.querySelector('img');
      if (!img) return;

      /* Der geklonte figure kann eine Vorschaufarbe oder ein LQIP des
         urspruenglichen Bildes als Hintergrund tragen — das gehoert zum
         alten Bild und muss weg. */
      var figure = clone.querySelector('figure');
      if (figure) figure.style.backgroundImage = '';

      /* width/height des alten Bildes wuerden ein fremdes Seitenverhaeltnis
         erzwingen. Der Container gibt das Verhaeltnis ohnehin vor
         (ratio-traditional), das Bild fuellt ihn per object-fit. */
      img.removeAttribute('width');
      img.removeAttribute('height');

      img.setAttribute('src', sized(240));
      img.setAttribute('srcset', WIDTHS.map(function (w) {
        return sized(w) + ' ' + w + 'w';
      }).join(', '));
      img.setAttribute('alt', ALT);

      title.insertBefore(clone, title.firstChild);
    });
  }

  function run() {
    try {
      build();
    } catch (e) {
      /* Eine fehlgeschlagene Verbesserung darf die Seite nicht blockieren. */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Theme-Editor: nach dem Neuaufbau des Headers erneut ansetzen. */
  document.addEventListener('shopify:section:load', run);
})();
